import React, { useState } from 'react';
import { Box, Typography, Container, Grid, Paper, Chip, Button } from '@mui/material';

const categories = ['All', 'IP Camera', 'Analog HD', 'NVR/DVR', 'Accessories'];

const products = [
  { name: 'Hikvision 4MP Dome Camera', category: 'IP Camera', price: '₹3,500', badge: 'Bestseller', color: '#1e90d4' },
  { name: 'Dahua 2MP Bullet Camera', category: 'Analog HD', price: '₹2,200', badge: '', color: '#2ecc71' },
  { name: 'CP Plus 8Ch NVR 4K', category: 'NVR/DVR', price: '₹12,000', badge: 'Popular', color: '#e74c3c' },
  { name: 'Hikvision PTZ 36x Zoom', category: 'IP Camera', price: '₹18,500', badge: 'Premium', color: '#9b59b6' },
  { name: 'Dahua 16Ch DVR Full HD', category: 'NVR/DVR', price: '₹9,800', badge: '', color: '#e67e22' },
  { name: '1TB Seagate CCTV HDD', category: 'Accessories', price: '₹3,200', badge: '', color: '#1abc9c' },
  { name: 'CP Plus 5MP Night Vision', category: 'Analog HD', price: '₹4,100', badge: 'New', color: '#f0c040' },
  { name: 'PoE 8-Port Switch', category: 'Accessories', price: '₹2,800', badge: '', color: '#1e90d4' },
];

export default function Products() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? products
    : products.filter(p => p.category === activeCategory);

  return (
    <Box
      id="products"
      sx={{
        py: 12,
        background: 'linear-gradient(180deg, #0a2540 0%, #081e35 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 7 }}>
          <Typography sx={{ fontSize: '0.8rem', letterSpacing: '3px', color: '#1e90d4', textTransform: 'uppercase', mb: 2, fontWeight: 600 }}>
            Our Range
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, color: '#e8f0fe', mb: 2 }}>
            Featured <Box component="span" sx={{ color: '#1e90d4' }}>Products</Box>
          </Typography>
          <Box sx={{ width: 60, height: 3, background: 'linear-gradient(90deg, #1e90d4, transparent)', mx: 'auto', borderRadius: 2 }} />
        </Box>

        {/* Filter tabs */}
        <Box sx={{ display: 'flex', gap: 1.5, mb: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
          {categories.map((cat) => (
            <Chip
              key={cat}
              label={cat}
              onClick={() => setActiveCategory(cat)}
              sx={{
                background: activeCategory === cat
                  ? 'linear-gradient(135deg, #1e90d4, #0a5a8a)'
                  : 'rgba(13,40,71,0.8)',
                border: activeCategory === cat
                  ? '1px solid #1e90d4'
                  : '1px solid rgba(30,144,212,0.2)',
                color: activeCategory === cat ? '#fff' : '#8fb3d9',
                cursor: 'pointer',
                fontWeight: activeCategory === cat ? 600 : 400,
                '&:hover': { borderColor: '#1e90d4', color: '#e8f0fe' },
                transition: 'all 0.2s',
                fontSize: '0.85rem', px: 0.5,
              }}
            />
          ))}
        </Box>

        <Grid container spacing={3}>
          {filtered.map((product, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Paper sx={{
                p: 3,
                background: 'rgba(13,40,71,0.6)',
                border: '1px solid rgba(30,144,212,0.12)',
                borderRadius: '12px',
                position: 'relative', overflow: 'hidden',
                cursor: 'pointer',
                '&:hover': {
                  border: `1px solid ${product.color}35`,
                  transform: 'translateY(-4px)',
                  boxShadow: `0 16px 40px rgba(0,0,0,0.3)`,
                },
                transition: 'all 0.3s',
              }}>
                {product.badge && (
                  <Chip
                    label={product.badge}
                    size="small"
                    sx={{
                      position: 'absolute', top: 12, right: 12,
                      background: `${product.color}22`,
                      border: `1px solid ${product.color}50`,
                      color: product.color, fontSize: '0.7rem', fontWeight: 600,
                    }}
                  />
                )}

                {/* Product icon placeholder */}
                <Box sx={{
                  width: '100%', height: 120,
                  background: `linear-gradient(135deg, ${product.color}10, ${product.color}05)`,
                  borderRadius: '8px', mb: 2,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: `1px solid ${product.color}15`,
                }}>
                  <Box sx={{
                    width: 50, height: 50,
                    background: `${product.color}20`,
                    borderRadius: '50%',
                    border: `2px solid ${product.color}40`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Box sx={{
                      width: 20, height: 20, borderRadius: '50%',
                      background: product.color, opacity: 0.7,
                    }} />
                  </Box>
                </Box>

                <Typography sx={{ color: '#e8f0fe', fontWeight: 600, fontSize: '0.9rem', mb: 0.5, lineHeight: 1.3 }}>
                  {product.name}
                </Typography>
                <Typography sx={{ color: '#8fb3d9', fontSize: '0.75rem', mb: 2 }}>
                  {product.category}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ color: '#1e90d4', fontWeight: 700, fontSize: '1.1rem' }}>
                    {product.price}
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{
                      borderColor: 'rgba(30,144,212,0.3)',
                      color: '#8fb3d9', fontSize: '0.7rem', px: 1.5,
                      '&:hover': { borderColor: '#1e90d4', color: '#e8f0fe' },
                    }}
                    onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    Enquire
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
